var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82568 17.3334C8.82568 17.7476 9.16147 18.0834 9.57568 18.0834C9.9899 18.0834 10.3257 17.7476 10.3257 17.3334L10.3257 10.6667C10.3257 10.2525 9.9899 9.91669 9.57568 9.91669C9.16147 9.91669 8.82568 10.2525 8.82568 10.6667L8.82568 17.3334ZM12.1772 9.91929C11.763 9.91929 11.4272 10.2551 11.4272 10.6693C11.4272 11.0835 11.763 11.4193 12.1772 11.4193H18.8439C19.2581 11.4193 19.5939 11.0835 19.5939 10.6693C19.5939 10.2551 19.2581 9.91929 18.8439 9.91929H12.1772ZM11.4116 14C11.4116 13.5858 11.7474 13.25 12.1616 13.25H18.8283C19.2425 13.25 19.5783 13.5858 19.5783 14C19.5783 14.4142 19.2425 14.75 18.8283 14.75H12.1616C11.7474 14.75 11.4116 14.4142 11.4116 14ZM12.1642 16.5807C11.75 16.5807 11.4142 16.9165 11.4142 17.3307C11.4142 17.7449 11.75 18.0807 12.1642 18.0807H18.8309C19.2451 18.0807 19.5809 17.7449 19.5809 17.3307C19.5809 16.9165 19.2451 16.5807 18.8309 16.5807H12.1642Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineListIcon);
export default __webpack_public_path__ + "static/media/line-list-icon.fef82d2504d56fcca0ed4f2089082c8b.svg";
export { ForwardRef as ReactComponent };